import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { faqQueries } from '@/services/faq/faq.queries';
import { useSearch } from '@tanstack/react-router';

export const useInquiries = () => {
  const { page, sort, fetch, q, createdDate } = useSearch({ from: '/(app)/faq/inquiry/' });
  const parsedCreatedDate = parseDateRangeSearch(createdDate);

  const { data, isLoading } = useQuery({
    ...faqQueries.inquiry({
      fetch: fetch,
      row: page,
      search: q ?? '',
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    inquiries: data?.data || [],
    pagination: data?.meta?.pagination ?? defaultMeta,
    loading: isLoading,
  };
};
